import React, { useContext } from 'react';
import { ContactDetailsFormValue, EditContactDetailsContext } from './EditContactDetailsContext';
import { getIntl } from '../../../../../utils/intl';
import ContactDetailsForm, { ContactDetailField } from '../../../../shared/ContactDetailsForm';
import urls from '../../../../../utils/urls';
import { AVATAR_UPLOAD_QUALITY } from '../../../../../utils/constants';
import { Field } from 'formik';
import { FormikInputs } from '../../../../v2BaseComponents/Inputs';

const intl = getIntl('contactDetails.editStep1', {
    continue: 'Continue',
    skip: 'Skip to Edit Contact Information',
    profilePhoto: 'Profile Photo',
    profileInformationDemographics: 'Demographics',
});

const step1ContactDetailsFields: ContactDetailField[] = [
    'firstName',
    'lastName',
    'preferredFirstName',
    'dob',
    'sex',
    'gender',
];

const step1RequiredFields: ContactDetailField[] = ['firstName', 'lastName', 'dob'];

export type EditStep1OwnProps = {};

export type EditStep1Props = EditStep1OwnProps;

const EditStep1: React.FC<EditStep1Props> = ({}) => {
    const { contactDetails, onContactDetailsChange, isUpdating, setStep } = useContext(EditContactDetailsContext);

    return (
        <ContactDetailsForm
            key={JSON.stringify(contactDetails)}
            initialValues={contactDetails}
            fields={step1ContactDetailsFields}
            required={step1RequiredFields}
            submitButtonTitle={intl('continue')}
            isDisabled={isUpdating}
            isSubmitting={isUpdating}
            extraFieldNames={['avatar']}
            onSubmit={(values) => {
                onContactDetailsChange(values as ContactDetailsFormValue);
                setStep('step2');
            }}
            nonDirtyActions={[
                {
                    title: intl('skip'),
                    onPress: () => {
                        setStep('step2');
                    },
                    icon: 'ArrowRight',
                },
            ]}
            renderFormStart={() => (
                <Field
                    name="avatar"
                    component={FormikInputs.TempAndExistingImagePicker}
                    existingAvatarUrl={urls.api.medicalProfiles.avatar(contactDetails.sourceEntityId)}
                    title={intl('profilePhoto')}
                    imagePickerOptions={{
                        allowsEditing: true,
                        aspect: [1, 1],
                        quality: AVATAR_UPLOAD_QUALITY,
                    }}
                    sizeVariant="avatar"
                />
            )}
        />
    );
};

export default React.memo(EditStep1);
